<div class="grid-container padding-y-4">
    <form [formGroup]="hhgOnlineBookShipmentForm" class="usa-form-large">
        <fieldset class="usa-fieldset">
            <div class="grid-row grid-gap-2">
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
                    <label class="usa-label text-bold margin-top-1">Identify the elements to be booked<abbr title="required"
                                                                                     class="usa-hint usa-hint--required">*</abbr></label>
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6 flex-container">
                    <div class="usa-checkbox" *ngFor="let booking of hhgOnlineBookShipmentForm.get('shipmentType')['controls']; let i=index;">
                      <input class="usa-checkbox__input" type="checkbox" [formControl]="booking"
                             title="{{bookingTypesRef[i].name}}" id="bookingTypes-{{i}}" />
                      <label class="usa-checkbox__label" for="bookingTypes-{{i}}"><strong> {{bookingTypesRef[i].name}}
                      </strong></label>
                    </div>
                  </div>
            </div>
            <div class="grid-row grid-gap-2">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 define-bg-blue padding-05">
                    <legend class="usa-legend usa-legend--medium">HOUSEHOLD GOODS - BOOK SHIPMENT</legend>
                </div>
            </div>
            <hr>
            <div class="grid-row grid-gap-2">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    <div class="grid-row grid-gap-2 padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                            Shipper :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                            {{ shipperInfo ? shipperInfo.firstName : '' }} {{shipperInfo ? shipperInfo.lastName : '' }}

                        </div>
                    </div>

                    <div class="grid-row grid-gap-2 padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                            Customer :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                            {{ agencyInfo ? agencyInfo.agencyBureauName : ''}}
                        </div>
                    </div>

                    <div class="grid-row grid-gap-2 padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                            Phone :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                            {{shipperInfo ? shipperInfo.phone : '' }}
                        </div>
                    </div>
                    <div class="grid-row grid-gap-2 padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                            Email :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                            {{shipperInfo ? shipperInfo.email : '' }}
                        </div>
                    </div>
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    <div class="grid-row grid-gap-2 padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                            TSP Contact:
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                            {{carrierOrganizationInfo ? carrierOrganizationInfo.firstName : ''}} {{carrierOrganizationInfo ? carrierOrganizationInfo.lastName : ''}}
                        </div>
                    </div>
                    <div class="grid-row grid-gap-2 padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                            SCAC:
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                            {{carrier ? carrier.scac : ''}}
                        </div>
                    </div>
                    <div class="grid-row grid-gap-2 padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                            Phone :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                            {{carrierOrganizationInfo ? carrierOrganizationInfo.phone : ''}}
                        </div>
                    </div>
                    <div class="grid-row grid-gap-2 padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                            Email :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                            {{carrierOrganizationInfo ? carrierOrganizationInfo.email : ''}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid-row grid-gap-2">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 define-bg-blue padding-05">
                    <legend class="usa-legend usa-legend--medium">SHIPMENT INFORMATION</legend>
                </div>
            </div>
            <hr>
            <div *ngIf="isCarrierView; else showShipperView" class="grid-row grid-gap-2">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label class="usa-label text-bold"> Book Shipment Id : {{ bookShipmentInfo.bookShipmentId }}</label>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <legend class="usa-legend usa-legend--medium">Relocating Employee</legend>
                    <div class="grid-row padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            Relocating Employee's First Name :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            {{shipmentLabelInfo.employeeFirstName}}
                        </div>
                    </div>
                    <div class="grid-row padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            Relocating Employee's Middle Initial :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            {{shipmentLabelInfo.employeeMiddleInitial}}
                        </div>
                    </div>
                    <div class="grid-row padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            Relocating Employee's Last Name :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            {{shipmentLabelInfo.employeeLastName}}
                        </div>
                    </div>
                    <div class="grid-row padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            Relocating Employee's Phone :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            {{ shipmentLabelInfo.employeePhone }}
                        </div>
                    </div>
                    <div class="grid-row padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            Relocating Employee's Email :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            {{shipmentLabelInfo.employeeEmail}}
                        </div>
                    </div>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <legend class="usa-legend usa-legend--medium">Designated Rep Releasing</legend>
                    <div class="grid-row  padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            Designated Rep Releasing First Name :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            {{shipmentLabelInfo.originatorFirstName}}
                        </div>
                    </div>

                    <div class="grid-row padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            Designated Rep Releasing Middle Initial :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            {{shipmentLabelInfo.originatorMiddleInitial}}
                        </div>
                    </div>

                    <div class="grid-row padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            Designated Rep Releasing Last Name :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            {{shipmentLabelInfo.originatorLastName}}
                        </div>
                    </div>

                    <div class="grid-row padding-y-05">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6 padding-right-105">
                            Enter origin, destination & other addresses :
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            <button type="button" class="usa-button" (click)="enterAddressModal()">
                                Addresses
                            </button>
                        </div>
                    </div>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <legend class="usa-legend usa-legend--medium">Shipment Information</legend>
                    <div class="grid-row grid-gap">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-05">
                            <div class="grid-row grid-gap">
                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                                    Requested Packing Date :
                                </div>
                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                    {{this.shipmentInfo.requestedPackingDate | date}}
                                </div>
                            </div>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-05">
                            <div class="grid-row grid-gap">
                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                                    Required Delivery Date :
                                </div>
                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                    {{this.shipmentInfo.requiredDeliveryDate | date}}
                                </div>
                            </div>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <label class="usa-label text-bold">Estimated Mileage :</label>
                            <label class="text-indent-105">{{ shipmentInfo.miles }}</label>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <label class="usa-label text-bold">Estimated Weight :</label>
                            <label class="text-indent-105">{{shipmentInfo.weight}}</label>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <label class="usa-label text-bold">Vehicle Shipped :</label>
                            <label class="text-indent-105">{{shipmentInfo.vehicleType}}</label>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <label class="usa-label text-bold">Unaccompanied Air Baggage :</label>
                            <label class="text-indent-105">{{shipmentInfo.uabWeight}}</label>
                        </div>

                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <label class="usa-label text-bold">SRO Selected :</label>
                            <label class="text-indent-105">{{ratesSroInfo?.sroType}}</label>
                        </div>

                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <label class="usa-label text-bold">Pre-Move Survey Type :</label>
                            <label class="text-indent-105">{{bookShipmentInfo.preMoveSurveyType}}</label>
                        </div>

                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <label class="usa-label text-bold">Pre-Move Survey Required :</label>
                            <label class="text-indent-105">{{bookShipmentInfo.preMoveSurveyReqd}}</label>
                        </div>

                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <label class="usa-label text-bold">Professional Books, Papers & Equipment :</label>
                            <label class="text-indent-105"> {{shipmentInfo.professionalBooksEquipments === 1 ? 'Yes' : 'No'}}</label>
                        </div>

                    </div>
                </div>
            </div>

            <ng-template #showShipperView>
                <div class="grid-row grid-gap">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                        <label class="usa-label">Book Shipment Id : <b>{{ bookShipmentInfo.bookShipmentId }}</b> </label>
                    </div>
                </div>
                <div class="grid-row grid-gap">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                        <label class=" padding-right-105">Enter origin, destination & other addresses: </label>
                        <button type="button" class="usa-button" (click)="enterAddressModal()">Addresses</button>
                    </div>
                </div>
                <div class="grid-row grid-gap-2">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                        <legend class="usa-legend usa-legend--medium">Employee</legend>
                        <div class="grid-row grid-gap">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="rel-emp-fname" class="usa-label">Relocating Employee's First Name <abbr
                                        title="required" class="usa-hint usa-hint--required">*</abbr></label>
                                <input type="text" placeholder="Enter Value Here" id="rel-emp-fname" class="usa-input" formControlName="employeeFirstName" size='45' maxlength='45' />
                                <ng-container *ngFor="let validation of validationMessages.employeeFirstName">
                                    <div class="define-text-secondary" *ngIf="hhgOnlineBookShipmentForm.get('employeeFirstName').hasError(validation.type) &&
                                      (hhgOnlineBookShipmentForm.get('employeeFirstName').dirty || hhgOnlineBookShipmentForm.get('employeeFirstName').touched)">
                                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                        </svg>{{ validation.message }}
                                    </div>
                                </ng-container>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="rel-emp-mi" class="usa-label">MI</label>
                                <input type="text" placeholder="Enter Value Here" id="rel-emp-mi" class="usa-input" formControlName="employeeMiddleInitial" size='1' maxlength='1' />
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="rel-emp-lname" class="usa-label">Last Name <abbr title="required"
                                        class="usa-hint usa-hint--required">*</abbr></label>
                                <input type="text" placeholder="Enter Value Here" id="rel-emp-lname" class="usa-input" formControlName="employeeLastName" size='45' maxlength='45' />
                                <ng-container *ngFor="let validation of validationMessages.employeeLastName">
                                    <div class="define-text-secondary" *ngIf="hhgOnlineBookShipmentForm.get('employeeLastName').hasError(validation.type) &&
                                        (hhgOnlineBookShipmentForm.get('employeeLastName').dirty || hhgOnlineBookShipmentForm.get('employeeLastName').touched)">
                                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                        </svg>{{ validation.message }}
                                    </div>
                                </ng-container>
                            </div>

                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="rel-emp-phone" class="usa-label">Relocating Employee's Phone</label>
                                <input type="text" placeholder="Enter Value Here" id="rel-emp-phone" class="usa-input" formControlName="employeePhone" size='15' maxlength='15' />
                                <div class="define-text-secondary" *ngIf="this.hhgOnlineBookShipmentForm.get('employeePhone').invalid && (this.hhgOnlineBookShipmentForm.get('employeePhone').touched || this.hhgOnlineBookShipmentForm.get('employeePhone').dirty) && (
                                    this.hhgOnlineBookShipmentForm.get('employeePhone').errors.numeric || this.hhgOnlineBookShipmentForm.get('employeePhone').errors.minlength)">
                                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                    </svg> Phone Number is invalid - should be all numeric, minimum 10 digits long, no dashes and no spaces
                                </div>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="rel-emp-email" class="usa-label">Email</label>
                                <input type="text" placeholder="Enter Value Here" id="rel-emp-email" class=" usa-input" formControlName="employeeEmail" size='45' maxlength='45' />
                                <div class="define-text-secondary" *ngIf="hhgOnlineBookShipmentForm.get('employeeEmail').hasError('pattern')">
                                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                    </svg> Email is invalid
                                </div>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="rel-emp-email" class="usa-label">Employee Unique Identifier</label>
                                <input type="text" id="rel-emp-EUI" class=" usa-input" formControlName="employeeUniqueIdentifier" maxlength='25' disabled />
                            </div>
                        </div>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                        <legend class="usa-legend usa-legend--medium">Designated Rep </legend>
                        <div class="grid-row grid-gap">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="des-rep-fname" class="usa-label">Designated Rep Releasing First Name</label>
                                <input type="text" placeholder="Enter Value Here" id="des-rep-fname" class="maxw-full usa-input" formControlName="originatorFirstName" size='45' maxlength='45' />
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="des-rep-mi" class="usa-label">MI</label>
                                <input type="text" placeholder="Enter Value Here" id="des-rep-mi" class="maxw-full usa-input" formControlName="originatorMiddleInitial" size='1' maxlength='1' />
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="des-rep-lname" class="usa-label">Last Name</label>
                                <input type="text" placeholder="Enter Value Here" id="des-rep-lname" class="maxw-full usa-input" formControlName="originatorLastName" size='45' maxlength='45' />
                            </div>
                        </div>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                        <legend class="usa-legend usa-legend--medium">Packing/Moving </legend>
                        <div class="grid-row grid-gap">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="packing-date" class="usa-label">Requested Packing Date</label>
                                <input type="text" id="packing-date" formControlName="requestedPackingDate" class="maxw-full usa-input" placeholder="mm/dd/yyyy" bsDatepicker [minDate]="minDate" [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }" (bsValueChange)="bsValueChange($event, 'requestedPackingDate')"
                                />
                                <div class="text-danger" *ngIf="this.hhgOnlineBookShipmentForm.get('requestedPackingDate').hasError('dateCompare')">
                                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                    </svg> Requested Packing Date should not be greater than Pickup/Move Date
                                </div>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="move-date" class="usa-label">Pickup/Move Date<abbr title="required"
                                        class="usa-hint usa-hint--required">*</abbr></label>
                                <input type="text" id="move-date" formControlName="moveDate" class="maxw-full usa-input" placeholder="mm/dd/yyyy" bsDatepicker [minDate]="minDate" [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }" (bsValueChange)="bsValueChange($event, 'moveDate')" />
                                <ng-container *ngFor="let validation of validationMessages.moveDate">
                                    <div class="define-text-secondary" *ngIf="hhgOnlineBookShipmentForm.get('moveDate').hasError('required') &&
                                      (hhgOnlineBookShipmentForm.get('moveDate').dirty || hhgOnlineBookShipmentForm.get('moveDate').touched)">
                                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                        </svg> {{ validation.message }}
                                    </div>
                                    <div class="define-text-secondary" *ngIf="this.hhgOnlineBookShipmentForm.get('moveDate').hasError('dateCompare')">
                                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                        </svg> Pickup/Move Date shold not be less than Requested Packing Date and should not be greater than Required Delivery Date
                                    </div>
                                </ng-container>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="delivery-date" class="usa-label">Required Delivery Date</label>
                                <input type="text" id="delivery-date" formControlName="requiredDeliveryDate" class="maxw-full usa-input" placeholder="mm/dd/yyyy" bsDatepicker [minDate]="minDate" [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }" (bsValueChange)="bsValueChange($event, 'requiredDeliveryDate')"
                                />
                                <div class="define-text-secondary" *ngIf="this.hhgOnlineBookShipmentForm.get('requiredDeliveryDate').hasError('dateCompare')">
                                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                    </svg>Required Delivery Date should not be less than Pickup/Move Date
                                </div>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label class="usa-label text-bold">Estimated Mileage:</label>
                                <label class="text-indent-105">{{shipmentInfo.miles}}</label>

                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label class="usa-label text-bold">Estimated Weight: </label>
                                <label class="text-indent-105">{{shipmentInfo.weight}}</label>

                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label class="usa-label text-bold">Vehicle Shipped:</label>
                                <label class="text-indent-105">{{shipmentInfo.vehicleType}}</label>

                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label class="usa-label text-bold">Unaccompanied Air Baggage: </label>
                                <label class="text-indent-105">{{shipmentInfo.uabWeight}}</label>

                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label class="usa-label text-bold">SRO selected:</label>
                                <label class="text-indent-105"> {{ratesSroInfo?.sroType}}</label>

                            </div>
                        </div>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                        <legend class="usa-legend usa-legend--medium">Pre-Move </legend>
                        <div class="grid-row grid-gap">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label class="usa-label" for="pre-move-survey-type">Pre-Move Survey Type:</label>
                                <select id="pre-move-survey-type" class="maxw-full usa-select" formControlName="preMoveSurveyType">
                                    <option value=null selected>None</option>
                                    <option *ngFor="let type of surveyTypes" value="{{type}}">{{type}}</option>
                                </select>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label class="usa-label" for="pre-move-survey-req">Pre-Move Survey Required:</label>
                                <select id="pre-move-survey-req" class="maxw-full usa-select" formControlName="preMoveSurveyReqd">
                                    <option value=null selected>None</option>
                                    <option *ngFor="let type of surveyReqTypes" value="{{type}}">{{type}}</option>
                                </select>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label class="usa-label" for="prof-book-papers-equip">Professional Books, Papers &
                                    Equipment</label>
                                <select id="prof-book-papers-equip" class="maxw-full usa-select" formControlName="professionalBooksEquipments">
                                    <option value="" selected>None</option>
                                    <option *ngFor="let type of optionalTypes" value="{{type}}">{{ type }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>

            <div class="grid-row grid-gap-2">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 define-bg-blue padding-05">
                    <legend class="usa-legend usa-legend--medium">SHIPMENT COST INFORMATION</legend>
                </div>
            </div>
            <hr>
            <div class="grid-row grid-gap">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    <div class="grid-row grid-gap">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <legend class="usa-legend usa-legend--medium">Cost</legend>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            <label class="usa-label text-bold">Type of Rate : </label>
                            <label class="text-indent-105">{{rateTypesInfo?.description }}</label>
                        </div>
                      <div *ngIf="!isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                        <label class="usa-label text-bold"> Vehicle Shipment Charge : </label>
                        <label class="text-indent-105">{{shipmentCostInfo?.vehicleCost | currency }}</label>

                      </div>
                        <div *ngIf="!isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                            <label class="usa-label text-bold">Surface Transportation % :  </label>
                            <label class="text-indent-105">{{surfacePercentage }}%</label>
                        </div>
                      <div *ngIf="!isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                        <label class="usa-label text-bold">Surface Transportation Charge :</label>
                        <label class="text-indent-105">{{shipmentCostInfo?.surfaceCost | currency }}</label>
                      </div>
                        <div *ngIf="!isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                            <label class="usa-label text-bold">Unaccompanied Air Baggage % : </label>
                            <label class="text-indent-105">{{ratesHhgInfo?.unaccompaniedAirBag}}%</label>
                        </div>
                      <div *ngIf="!isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                        <label class="usa-label text-bold">Unaccompanied Air Baggage Charge :</label>
                        <label class="text-indent-105">{{shipmentCostInfo?.uabCost | currency }}</label>
                      </div>
                        <div *ngIf="isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                            <label class="usa-label text-bold">Packing/Loading/Drayage Cost : </label>
                            <label class="text-indent-105">{{shipmentCostInfo?.vehicleCost | currency }}</label>
                        </div>
                        <div *ngIf="!isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                            <label class="usa-label text-bold">30 Days Storage In Transit : </label>
                            <label class="text-indent-105">{{shipmentCostInfo?.sit30DayCost | currency }}</label>

                        </div>
                        <!--<div *ngIf="!isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                            <label class="usa-label text-bold">30 Days Storage In Transit : </label>
                            <label class="text-indent-105">{{shipmentCostInfo?.sit30DayCost | currency }}</label>

                        </div>-->
                      <div *ngIf="!isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                        <label class="usa-label text-bold">60 days Storage In Transit : </label>
                        <label class="text-indent-105">{{shipmentCostInfo?.sit60DayCost | currency }}</label>

                      </div>
                        <div *ngIf="!isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                            <label class="usa-label text-bold"> 90 Days Storage In Transit : </label>
                            <label class="text-indent-105">{{shipmentCostInfo?.sit90DayCost | currency }}</label>
                        </div>
                      <div *ngIf="isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                        <label class="usa-label text-bold">Total Cost (1 Month) :  </label>
                        <label class="text-indent-105">{{shipmentCostInfo?.uabCost | currency }}</label>

                      </div>
                        <div *ngIf="isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                            <label class="usa-label text-bold"> Total Cost (12 Months) :  </label>
                            <label class="text-indent-105">{{shipmentCostInfo?.totalCost | currency }}</label>

                        </div>
                      <div *ngIf="isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                        <label class="usa-label text-bold">Total Cost (6 months) : </label>
                        <label class="text-indent-105">{{shipmentCostInfo?.vehicleCost | currency }}</label>

                      </div>
                        <div *ngIf="isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                            <label class="usa-label text-bold">Tender Id :</label>
                            <label class="text-indent-105">  {{ ratesHhgInfo?.tenderId}}</label>

                        </div>
                        <div *ngIf="isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                            <label class="usa-label text-bold">Warehouse Handling Cost : </label>
                            <label class="text-indent-105">{{shipmentCostInfo?.sitWarehouseCost | currency }}</label>

                        </div>
                        <div *ngIf="!isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                            <label class="usa-label text-bold"> Total Transportation Charge : </label>
                            <label class="text-indent-105">{{shipmentCostInfo?.totalCost | currency }}</label>

                        </div>
                        <div *ngIf="isExtendedStorage" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                            <label class="usa-label text-bold"> Monthly Storage Cost : </label>
                            <label class="text-indent-105">{{shipmentCostInfo?.surfaceCost | currency }}</label>

                        </div>

                        <div for="accessorials" class="grid-col-12 mobile-lg:grid-col-6 tablet:grid-col-6">
                            <label class="usa-label text-bold">SIT and Other Accessorial Services : </label>
                            <button type="button" class="usa-button" (click)="enterAccessorialModal()">Accessorials</button>
                        </div>
                    </div>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">

                    <div class="grid-row grid-gap">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <legend class="usa-legend usa-legend--medium">Location</legend>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            <div class="grid-row grid-gap">
                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                    <h4>Origin</h4>
                                </div>

                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                    <label class="usa-label text-bold"> City, State and Zip : </label>
                                    <label class=" text-indent-105">{{originAddress}}</label>
                                </div>
                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                    <label class="usa-label text-bold"> Country : </label>
                                    <label class="text-indent-105">{{originCountry}}</label>
                                </div>
                            </div>
                        </div>

                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            <div class="grid-row grid-gap">
                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                    <h4>Destination</h4>
                                </div>

                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                    <label class="usa-label text-bold"> City, State and Zip : </label>
                                    <label class="text-indent-105">{{destinationAddress}}</label>
                                </div>
                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                    <label class="usa-label text-bold"> Country : </label>
                                    <label class="text-indent-105">{{destinationCountry}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="!isCarrierView">
                <div class="grid-row grid-gap-2">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 define-bg-blue padding-05">
                        <legend class="usa-legend usa-legend--medium">BOOKING</legend>
                    </div>
                </div>
                <hr>
                <div class="grid-row grid-gap-2">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                        <div class="grid-row grid-gap">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3 usa-checkbox">
                                <legend class="usa-legend usa-legend--medium">Off-Line Booking</legend>
                                <input type="checkbox" title="HHG" class="usa-checkbox__input" id="olBooking" formControlName="bookingType" (change)="changeBookingType($event)" />
                                <label for="olBooking" class="usa-checkbox__label"><strong>Off-Line Booking</strong></label>
                                <p>If you are using Off-line booking, please contact the TSP to verify shipment acceptance prior to continuing</p>
                            </div>

                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                                <legend class="usa-legend usa-legend--medium">On-Line Booking</legend>
                                <div class="grid-row grid-gap">
                                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                        <label for="tspResponseInDays" class="usa-label">Select Number of Days Allowed for TSP
                                            Response.</label>
                                        <select id="tspResponseInDays" class="width-full usa-select" formControlName="tspResponseInDays" (change)="changeTspResponse($event)">
                                            <option *ngFor="let number of numberOfDays" value="{{ number }}">{{ number }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                        <label for="tspResponseInHours" class="usa-label">Select Number of Hours Allowed for TSP
                                            Response.</label>
                                        <select id="tspResponseInHours" class="width-full usa-select" formControlName="tspResponseInHours" (change)="changeTspResponse($event)">
                                            <option *ngFor="let number of numberOfHours" value="{{ number }}">{{ number }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                <div class="grid-row grid-gap">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 define-bg-blue padding-05">
                        <legend class="usa-legend usa-legend--medium">PREFERRED LOCAL AGENT / COMMENTS</legend>
                        <hr>
                    </div>
                </div>
                <div class="grid-row grid-gap-2">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                        <legend class="usa-legend usa-legend--medium">Preferred Local Agent</legend>
                        <div class="grid-row grid-gap">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="localAgentSelected" class="usa-label">Select local agent</label>
                                <select id="localAgentSelected" class="width-full usa-select" formControlName="localAgentSelected" (change)="onLocalAgentRequiredSelecion($event.target.value)">
                                    <option value='' selected>None</option>
                                    <option *ngFor="let type of optionalTypes" value="{{type}}">{{type}}</option>
                                </select>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label for="prefLocalAgent" class="usa-label">Select preferred local agent</label>
                                <select *ngIf="prefLocalAgentList" id="prefLocalAgent" class="width-full usa-select" formControlName="prefLocalAgent" (change)="onPreferredAgentSelecion($event)">
                                    <option value="" selected>None</option>
                                    <option *ngFor="let type of prefLocalAgentList" value="{{type.localAgentId}}">
                                        {{type.agentScac}}
                                    </option>
                                </select>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-05">
                                Preferred Agent Name : {{requestedLocalAgentInfo?.agentName}}
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-05">
                                Phone : {{requestedLocalAgentInfo?.agentPhone}}
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-05">
                                Email : {{requestedLocalAgentInfo?.agentEmail}}
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-05">
                                Agent assigned by TSP : {{assignedLocalAgentInfo?.agentName}}
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-05">
                                Phone : {{assignedLocalAgentInfo?.agentPhone}}
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-05">
                                Email : {{assignedLocalAgentInfo?.agentEmail}}
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isCarrierView" class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                        <div class="grid-row grid-gap">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label class="usa-label">Select Agent to Assign</label>
                                <select class="usa-select">
                                    <option></option>
                                    <!-- Enable this when the assigned agent object/array is defined-->
                                    <!-- option *ngFor="let item of carrierRejectOptions" [value]="item">{{item}}</option-->
                                </select>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label class="usa-label">Employee Unique Identifier (Optional):</label>
                                <input type="text" placeholder="Enter Value Here" id="rel-emp-eui" class="maxw-full usa-input" formControlName="employeeUniqueIdentifier" size="45" maxlength="25" />
                            </div>
                        </div>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                        <legend class="usa-legend usa-legend--medium">Comments</legend>
                        <div class="grid-row grid-gap">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label class="usa-label">Shipper Additional Comments</label>
                                <textarea class="usa-textarea" formControlName="additionalComments" maxlength="200" [attr.disabled]="!isCarrierView?null:true"></textarea>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                                <label class="usa-label">TSP Additional Comments</label>
                                <textarea class="usa-textarea" formControlName="tspAdditionalComments" maxlength="200" [attr.disabled]="isCarrierView?null:true"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-row grid-gap-2">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <legend class="usa-legend usa-legend--medium">STATUS: {{ bookShipmentInfo.bookingStatus }}</legend>
                </div>
            </div>

            <div *ngIf="isCarrierView">
                <div class="grid-row grid-gap">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                        <label class="usa-label">Accept/Refuse Booking</label>
                        <select class="usa-select" (change)="acceptRefuseBookingChanged($event.target.value)" formControlName="carrierAcceptRefuseStatus">
                                <option *ngFor="let item of carrierAcceptRefuseOptions" [value]="item">
                                    {{item}}</option>
                            </select>
                    </div>
                </div>
                <div class="grid-row grid-gap-2 padding-bottom-1" *ngIf="acceptRejectionWithReason">
                    <div id="accept" *ngIf="isAcceptedWithQualificationByCarrier; else isRefusedByCarrier" class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                        <div clas="grid-row grid-gap-2">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                <label class="usa-label">Ready For Acceptance With Qualifications</label>
                                <select class="usa-select" (change)="acceptedWithQualificationReasonChanged($event.target.value)" formControlName="carrierAcceptOption">
                                    <option *ngFor="let item of carrierAcceptOptions" [value]="item">{{item}}
                                    </option>
                                </select>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6" *ngIf="acceptSpecifyReason">
                                <label class="usa-label">Specify Reason</label>
                                <input type="text" id="specifyAcceptReason" class="width-full usa-input" formControlName="carrierAcceptReason">
                            </div>
                        </div>
                    </div>
                    <ng-template #isRefusedByCarrier>
                        <div id="refuse" class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-bottom-1">
                            <div clas="grid-row grid-gap-2">
                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                                    <label class="usa-label">Reason For Refusal</label>
                                    <select class="usa-select" (change)="refusedReasonChanged($event.target.value)" formControlName="carrierRefuseOption">
                                        <option *ngFor="let item of carrierRejectOptions" [value]="item">
                                            {{item}}</option>
                                    </select>
                                </div>
                                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6" *ngIf="rejectSpecifyReason">
                                    <label class="usa-label">Specify Reason</label>
                                    <input type="text" id="specifyRejectReason" class="usa-input" formControlName="carrierRefuseReason">
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div *ngIf="acceptRejectionWithReason && !isCarrierView" class="grid-row grid-gap-2 padding-bottom-1">
                <div id="accept" *ngIf="isAcceptedWithQualificationByCarrier && this.bookShipmentInfo.refusalOrQualificationReason; else isRefusedByCarrier" class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <div class="grid-row grid-gap-2">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                            <label class="usa-label">Acceptance With Qualifications</label>
                            <select class="usa-select" formControlName="carrierAcceptOption" [attr.disabled]="true">
                                <option *ngFor="let item of carrierAcceptOptions" [value]="item">{{item}}
                                </option>
                            </select>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="this.bookShipmentInfo.refusalOrQualificationRemarks">
                            <label class="usa-label">Reason Details</label>
                            <input type="text" id="specifyAcceptReason" class="width-full usa-input" [attr.disabled]="true" formControlName="carrierAcceptReason">
                        </div>
                    </div>
                </div>
                <ng-template #isRefusedByCarrier>
                    <div id="refuse" class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="this.bookShipmentInfo.refusalOrQualificationReason;">
                        <div class="grid-row grid-gap-2">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                                <label class="usa-label">Reason For Refusal</label>
                                <select class="usa-select" [attr.disabled]="true" formControlName="carrierRefuseOption">
                                    <option *ngFor="let item of carrierRejectOptions" [value]="item">{{item}}
                                    </option>
                                </select>
                            </div>
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="this.bookShipmentInfo.refusalOrQualificationRemarks">
                                <label class="usa-label">Reason Details</label>
                                <input type="text" id="specifyRejectReason" class="width-full usa-input" [attr.disabled]="true" formControlName="carrierRefuseReason">
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>

            <div class="grid-row grid-gap margin-top-2">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <button type="button" class="usa-button" (click)="validateConfirm()" [disabled]="(this.disabledConfirm || disabled || (hhgOnlineBookShipmentForm.invalid && !isCarrierView))">Confirm</button>
                    <button type="button" class="usa-button" (click)="saveShipment(null)" [disabled]="disabled || (hhgOnlineBookShipmentForm.invalid && !isCarrierView)">Save Shipment Details</button>
                    <!-- <span *ngIf="(bookShipmentInfo.bookingStatus === 'Accepted' || bookShipmentInfo.bookingStatus === 'Accepted with Qualification') && !isCarrierView"> -->
                    <button *ngIf="(bookShipmentInfo.bookingStatus === 'Accepted' || bookShipmentInfo.bookingStatus === 'Accepted with Qualification') && !isCarrierView" type="button" class="usa-button" (click)="viewBillOfLading()">Continue to Bill Of Lading Details</button>
                    <!-- </span> -->
                    <button type="button" class="usa-button" (click)="viewBookingAuditTrial()">View Booking Audit Trail</button>
                    <button *ngIf="!isCarrierView" type="button" class="usa-button usa-button--outline" (click)="cancelShipment()" [disabled]="disabled">Cancel Booking</button>
                </div>
            </div>
        </fieldset>
    </form>
</div>
